import React from 'react';
import styled from 'styled-components';
import { compose } from 'redux';
import DashboardTemplate from 'components/templates/Dashboard';
import HeaderContainer from 'containers/HeaderContainer';
import PageQuery from 'hoc/PageQuery';
import PageView from 'hoc/PageView';
import PageTitle from 'hoc/PageTitle';
import ProtectedRoute, { DashboardsProtections } from 'hoc/ProtectedRoute';
import PageTheme from 'hoc/PageTheme';

import LayerThreeEmbeddedContainer from 'containers/dashboards/LayerThreeEmbeddedContainer';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/DashboardSideBarObjects';
import { getQueryParamDefForRange } from 'helpers/range';
import showGGBrandingTheme from 'helpers/showGGBrandingTheme';

const DBTemplateNoMargin = styled(DashboardTemplate)`
    margin-left: 0px;
    margin-right: 0px;
`;

const CustomDashboard = props => (
    <DBTemplateNoMargin
        header={<HeaderContainer />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer hideDatePicker={true} entityId={parseInt(props.match.params.entityId, 10)}/>}>
        <LayerThreeEmbeddedContainer slug={props.match.params.slug} {...props} />
    </DBTemplateNoMargin>
);

export default compose(
    ProtectedRoute(DashboardsProtections),
    PageTitle({ pageTitle: 'Custom' }),
    PageView({ page: 'Viewed Entity Custom', trackEntity: true }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': showGGBrandingTheme } }),
    PageQuery({
        params: {
            ...getQueryParamDefForRange()
        },
        initialTruth: 'location',
    }),
)(CustomDashboard);



// WEBPACK FOOTER //
// ./src/components/pages/dashboards/Custom.js